let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kxQbf")).then(() => parcelRequire('g8wZ9'));